var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgShopIcon = function SvgShopIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 27,
    viewBox: "0 0 28 27",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.572 1)",
    stroke: "#171717",
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 9.247,
    cy: 23.117,
    r: 1.156
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 21.961,
    cy: 23.117,
    r: 1.156
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h4.623l3.098 15.477a2.312 2.312 0 0 0 2.312 1.86h11.234a2.312 2.312 0 0 0 2.312-1.86l1.85-9.698H5.778"
  }))));
};
export default SvgShopIcon;